import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, KeyRound } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "../lib/api";
import { useAuth } from "../lib/auth";

export const AccountSettings = () => {
  const { user, setUser } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.post("/auth/change-email", { new_email: email, current_password: password });
      setUser(r.data);
      setEmail("");
      setPassword("");
      toast.success("Correo de acceso actualizado");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="card-warm p-6 space-y-4 mb-6" data-testid="account-settings">
      <h2 className="font-serif text-xl font-semibold text-[#13302A]">Cuenta de acceso al Estudio</h2>
      <p className="text-base text-[#3F433C]">
        Correo actual para ingresar: <strong data-testid="account-current-email">{user?.email}</strong>. A este correo llegan los enlaces de «Olvidé mi contraseña».
      </p>
      <form onSubmit={save} className="grid md:grid-cols-2 gap-4">
        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-warm" placeholder="Correo nuevo" data-testid="account-new-email-input" />
        <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="input-warm" placeholder="Tu contraseña actual" autoComplete="current-password" data-testid="account-email-password-input" />
        <div className="md:col-span-2 flex flex-wrap gap-3">
          <button type="submit" disabled={busy} className="btn-gold" data-testid="account-change-email-button">
            <Mail size={16} /> {busy ? "Guardando…" : "Cambiar correo de acceso"}
          </button>
          <Link to="/estudio/cambiar-clave" className="btn-ghost" data-testid="account-change-password-link">
            <KeyRound size={16} /> Cambiar contraseña
          </Link>
        </div>
      </form>
    </div>
  );
};
